import script from "./SendBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendBalance.vue?vue&type=script&setup=true&lang=ts"

import "./SendBalance.vue?vue&type=style&index=0&id=e786b69e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e786b69e"]])

export default __exports__